import cn from 'classnames'
import React from 'react'

import styles from './BackButton.module.scss'

import ArrowIcon from '~shared/icons/16/arrow.svg'

type BackButtonProps = React.HTMLAttributes<HTMLButtonElement>

function BackButton({ children, className, ...props }: React.PropsWithChildren<BackButtonProps>) {
  return (
    <button type="button" className={cn(styles.root, className)} {...props}>
      <span className={styles.before}>
        <ArrowIcon className={styles.arrow} />
      </span>
      {children && <span className={styles.content}>{children}</span>}
    </button>
  )
}

export default BackButton
